import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import { VScroll } from 'app/views/core/Scroll'

import moment from 'moment'

// TODO: Stylesheets, man, let's just use stylesheets
const Container = ({ children }) => (
  <div style={{
    flexBasis: 0,
    flexGrow: 1,
    borderTop: '1px solid #eee',
    backgroundColor: '#333',
    color: '#eee',
    whiteSpace: 'pre',
    fontFamily: '"Roboto Mono", Consolas, "Andale Mono", "Lucida Console", "DejaVu Sans Mono", Monaco, "Courier New", Courier, monospace',
    fontSize: 14,
    lineHeight: 1.25,  
  }}>
    {children}
  </div>
)
const Line = ({ timestamp, text }) => (
  <div>
    <span style={{ color: '#999' }}>{moment(timestamp).format('HH:mm:ss')}</span> {text}
  </div>
)

function SandboxOutputFeed(props) {
  const { hasCode, lines } = props
  const scrollRef = useRef()
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [lines.length])

  return (
    <Container>
      <VScroll ref={scrollRef}>
        <div style={{ padding: 10 }}>
          {lines.length > 0 ? (
            lines.map(({ timestamp, text }, i) => (
              <Line key={i} timestamp={timestamp} text={text} />
            ))
          ) : hasCode && (
            <>
              <div>Output from your code will appear here.</div>
              <div>&nbsp;</div>
              <div>After adding print statements in the Code Editor:</div>
              <div>- Click "Save Code" to apply your changes to the sandbox.</div>
              <div>- Use the browser tab to make the sandbox run your code.</div>
            </>
          )}
        </div>
      </VScroll>
    </Container>
  )
}
SandboxOutputFeed.propTypes = {
  hasCode: PropTypes.bool.isRequired,
  lines: PropTypes.arrayOf(PropTypes.shape({
    timestamp: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
}

export default SandboxOutputFeed
